import * as React from "react"
import { Link } from "gatsby"

const HomeItem = ({ item }) => {
  return (
    <li className="homeItem">
      <Link to={"/detail/"+item.slug}>
        <div className="homeItem-single">
          <img
            src={item.image}
            alt={item.name}
          />
          <h3>{item.name}</h3>
        </div>
      </Link>
    </li>
  )
}

export default HomeItem
